import { OrganizationKeyName } from "../../model/Organization";
import { PromotionCodeListItem } from "../../service/api-response/PromotionCodesSuccessResponse";
import { RootState } from "../../store";

export const promotionCodeList = (
  state: RootState,
  org: OrganizationKeyName
): PromotionCodeListItem[] => {
  return state.promotionCode.organization[org] || [];
};

export const isLoadingPromotionCodeList = (
  state: RootState,
  org: OrganizationKeyName
): boolean => {
  return state.promotionCode.isLoadingPromotionCodeList[org] || false;
};

export const hasNextPage = (
  state: RootState,
  org: OrganizationKeyName
): boolean => {
  const hasNext = state.promotionCode.hasNextPage[org];

  return hasNext === undefined ? true : hasNext;
};
